import { IDefineCommand, IQuery } from 'core-ts-types';
import { TransientAccessCredWorkflowModel } from '../models/transient_access_cred_workflow_model';
import { ITransientAccessCredWorkflow } from '../builders/transient_access_cred_workflow_builder';

export type UpdateTransientAccessCredWorkflowCommand = (
  accessCred: ITransientAccessCredWorkflow
) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'updateTransientAccessCredWorkflowCommand',
    (ngTransientAccessCredWorkflowModel: TransientAccessCredWorkflowModel, defineCommandORM: IDefineCommand) =>
      defineCommandORM(
        'updateTransientAccessCredWorkflowCommand',
        (deferred, workflowUpdate: ITransientAccessCredWorkflow) => {
          ngTransientAccessCredWorkflowModel.write(workflowUpdate);
          deferred.resolve();
        }
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/prevent_transient_access/commands/update_transient_access_cred_workflow_command.ts